import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { WidgetData } from '../../../../_common/platform/ts/WidgetData';
import ConfigEdit from '../react/ConfigEdit';
import ConfigPopupFooter from '../react/ConfigPopupFooter';
import * as Utils from '../../../../_common/platform/ts/Utilities';
import * as reactGlobalClick from '../../../../_common/platform/ts/reactGlobalClick';

declare var CKEDITOR;

function getWidgetTitle(data) {
    if (data == null || data.type == null) {
        return null;
    }

    return data.values[data.type].name;
}

function setWidgetTitle(titleElement, config) {
    if (titleElement == null) {
        return;
    }

    const titleValue = getWidgetTitle(config[0]);

    if (titleValue != null) {
        titleElement.setHtml(
            titleValue
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;')
        );
    } else {
        titleElement.setHtml('Widget is empty');
    }
}

function setWidgetSize(element, settings) {
    element.removeClass('auto-size');
    element.removeClass('inline-mode');
    element.removeClass('inline-height-set'); //LL
    element.removeClass('width-set'); //LL
    element.removeClass('height-set'); //LL: 26.11.21
    element.removeClass('wh-mode'); //LL 18-19.11.21 was try
    element.removeClass('width-not-set'); //LL 18-19.11.21 was try
    element.setStyles({
        overflowY: null,
        height: null,
        width: null
    });

    if (settings.autoSize) {
        element.addClass('auto-size');
        if (settings.preserve === 'width' && settings.width > 0) {
            element.addClass('width-set');
            element.setStyles({
                width: settings.width + (settings.wUnits != null) ? settings.wUnits : 'px',
                height: 'auto'
            });
        }
        if (settings.preserve === 'height' && settings.height > 0) {
            element.addClass('height-set'); //LL: 26.11.21
            element.setStyles({
                //overflowY: "auto", //LL: good for Grids, bad for Charts (Chart is resized in container)
                //display: "block", //LL: try, no good
                height: settings.height + 'px',
                width: 'auto'
            });
        }
    } else if (settings.inlineMode) {
        element.addClass('inline-mode');

        //LL: 11.10.21: preserve
        if (settings.preserve === 'width' && settings.width > 0) {
            element.addClass('width-set');
            element.setStyles({
                display: 'inline-block',
                width: settings.width + (settings.wUnits != null ? settings.wUnits : 'px'),
                height: 'auto'
            });
        }
        if (settings.preserve === 'height' && settings.height > 0) {
            element.addClass('inline-height-set');
            element.setStyles({
                display: 'inline-block',
                height: settings.height + 'px',
                //width: "auto"
                width: '100%'
            });
        }

        //LL: 14.12.21: for inner Widget (for example KPI inside Template of Cards Widget)
        //   Or maybe introduce checkbox "is Inline Widget"
        if ((settings.height == null || settings.height === 0) && (settings.width == null || settings.width === 0)) {
            element.setStyles({
                display: 'inline-block',
                height: 'auto',
                width: 'auto'
            });
        }
    } else {
        let hNotSet = settings.height == null || settings.height === 0;
        let wNotSet = settings.width == null || settings.width === 0;
        //LL: 25.11.21:
        //if (hNotSet) {
        //    element.addClass('auto-size');
        //    element.addClass('width-set');
        //}
        //LL: 26.11.21:
        if (hNotSet || wNotSet) {
            element.addClass('auto-size');
            if (!wNotSet) {
                element.addClass('width-set');
            }
            if (!hNotSet) {
                element.addClass('height-set');
            }
        }

        //LL: 25.11.21: try set good for Grid and deal with Height inside Chart Module
        //   ("auto" bad for Charts, good for Grid; "100%" good for Charts, bad for Grid)
        let h = hNotSet ? 'auto' : settings.height + (settings.hUnits != null ? settings.hUnits : 'px');
        //let h = hNotSet ? "100%" : settings.height + 'px';

        let w = wNotSet ? 'auto' : settings.width + (settings.wUnits != null ? settings.wUnits : 'px');

        element.setStyles({
            height: h,
            width: w
        });
    }
}

function getDefaultConfig(glob) {
    const defaultData = WidgetData.getEmpty(glob);

    defaultData.id = defaultData.cid;

    return [defaultData.getDataForSave()];
}

function getDefaultSettings(input) {
    return _.extend(
        {
            width: 640,
            height: 480,
            inlineMode: false,
            autoSize: false,
            preserve: 'none', //LL: 07.10.21
            margins: null //LL: 08.06.22
        },
        input
    );
}

export function getWidgetDefinition({
    glob,
    editor,
    defaultConfig,
    defaultSettings,
    configEditProps,
    dialogTitle,
    definitionOverride,
    className,
    upcastPriority
}: {
    glob: IGlob;
    editor;
    defaultConfig;
    defaultSettings;
    configEditProps;
    dialogTitle: string;
    definitionOverride;
    className: string;
    upcastPriority;
}) {
    if (defaultConfig == null) {
        defaultConfig = getDefaultConfig(glob);
    }

    const definition = {
        template:
            '<span ' +
            'class="cke-pdc-widget ' +
            (className != null ? ' ' + className : '') +
            '" ' +
            'data-widget-config="__WIDGET_CONFIG_START__' +
            btoa(unescape(encodeURIComponent(JSON.stringify(defaultConfig)))) +
            '__WIDGET_CONFIG_END__" ' +
            'data-settings="' +
            btoa(unescape(encodeURIComponent(JSON.stringify(getDefaultSettings(defaultSettings))))) +
            '"' +
            '></span>',

        allowedContent:
            'span[data-settings,data-widget-config](cke-pdc-widget,auto-size,inline-mode' +
            (className != null ? ',' + className : '') +
            ')',

        defaults: {
            config: defaultConfig
        },

        upcastPriority,

        upcast: function (element) {
            let flag = element.name == 'span' && element.hasClass('cke-pdc-widget');

            if (className != null) {
                flag = flag && element.hasClass(className);
            }

            return flag;
        },

        init: function () {
            const configStr = this.element
                .getAttribute('data-widget-config')
                .replace(/^__WIDGET_CONFIG_START__/, '')
                .replace(/__WIDGET_CONFIG_END__$/, '');

            const config = JSON.parse(decodeURIComponent(escape(atob(configStr))));

            //EVG: When adding a widget its ID must be unique.
            // Also see Issue 87165: If a widget is already added, ID should not be updated.
            if (Array.isArray(config)) {
                config.forEach((value) => {
                    if (value.id == null || value.cid == null || value.type == null || _.isEmpty(value.values)) {
                        value.id = value.cid = Utils.getNewID();
                    }
                });
            }

            setWidgetTitle(this.element, config);

            const settingsStr = this.element.getAttribute('data-settings');
            const settings = JSON.parse(atob(settingsStr));

            setWidgetSize(this.element, settings);

            this.setData('config', config);
            this.setData('settings', settings);
        },

        data: function () {
            // var jsonContainer = this.element.findOne('.json-data');
            // var title = this.element.findOne('.title');

            setWidgetTitle(this.element, this.data.config);

            this.element.setAttribute(
                'data-widget-config',
                '__WIDGET_CONFIG_START__' +
                btoa(unescape(encodeURIComponent(JSON.stringify(this.data.config)))) +
                '__WIDGET_CONFIG_END__'
            );

            this.element.setAttribute(
                'data-settings',
                btoa(unescape(encodeURIComponent(JSON.stringify(this.data.settings))))
            );

            setWidgetSize(this.element, this.data.settings);

            editor.fire('change');
        },

        edit: function (e) {
            e.cancel();

            let value = {
                widget: this.data.config,
                inlineMode: this.data.settings.inlineMode,
                autoSize: this.data.settings.autoSize,
                preserve: this.data.settings.preserve, //LL: 07.10.21
                width: this.data.settings.width,
                wUnits: this.data.settings.wUnits,
                height: this.data.settings.height,
                hUnits: this.data.settings.hUnits,
                margins: this.data.settings.margins //LL: 08.06.22
            };

            var _this = this;

            function getwidgetDataEdit() {
                let obj;

                if (value.widget && value.widget && value.widget.length > 0) {
                    obj = value.widget[0];
                }
                return (widgetDataEdit = WidgetData.getFromObj(obj, glob, false, null, _this.editor.tabID || _this.editor.config.parentTabID));
            }

            function normalizeText(widgetDataEdit) {
                let text: string;

                if (widgetDataEdit !== null) {
                    const data = JSON.parse(JSON.stringify(widgetDataEdit.getDataForSave())); //clone nested objects

                    Utils.jsonNormalize_DataSourceIDToName(data, glob);
                    Utils.jsonNormalize_ThemeIDToName(data, glob);
                    text = JSON.stringify(data, null, '\t');
                }
                return text;
            }

            function clipboardCopyClick() {
                const widgetDataEdit = getwidgetDataEdit();
                const text = normalizeText(widgetDataEdit);

                glob.AppStore.saveToLocalStorage('pdc_clipboard_data', text);
            }

            var widgetDataEdit = getwidgetDataEdit();
            var text = normalizeText(widgetDataEdit);

            function onChange(value_) {
                //LL: 25.12.23: prohibit Width in "%" if not "inline": (maybe at least for Chart & Gauge: value.widget.type)
                let vvv: any = $.extend(true, {}, value_);

                if (value.inlineMode === true && vvv.inlineMode === false) {
                    if (vvv.wUnits === '%') {
                        vvv.wUnits = 'px';
                    }
                }

                value = vvv;
            }

            const tabID = _this.editor.tabID || _this.editor.config.parentTabID;

            glob.DialogActions.createDialog(
                dialogTitle || 'Widget Configuration',
                null,
                function () {
                    const editFields = ConfigEdit.getEditFields(value, glob, tabID);
                    const def = $.Deferred();

                    if (ConfigEdit.validateFields(value, editFields)) {
                        def.resolve();
                    } else {
                        def.reject();
                    }

                    return def.then(() => {
                        _this.setData('config', value.widget);

                        //LL: 25.11.21: No, it is used if not inlineMode and H or/and W is not set
                        //LL: 15.10.21: to eliminate autoSize.
                        // Unset autoSize if possible:
                        let autoSize = value.autoSize;
                        let inlineMode = value.inlineMode;

                        //LL: 25.11.21: commented
                        //if (value.autoSize) {
                        //    //LL: can be if for example Width is changed
                        //    autoSize = false;
                        //    inlineMode = true;
                        //}

                        //LL: 25.11.21: if inlineMode is set => remove autoSize (now only single checkbox for inlineMode)
                        if (value.inlineMode === true) {
                            autoSize = false;
                        }

                        //LL: 15.10.21: do not use "preserve" in GUI, use Null Width instead: (Height is not used when InlineMode)
                        let preserve = value.preserve;

                        let wNotSet = value.width == null || value.width === 0;
                        let hNotSet = value.height == null || value.height === 0;

                        if (value.autoSize || value.inlineMode) {
                            if (wNotSet) {
                                preserve = 'none';
                            } else {
                                preserve = 'width';
                            }
                            //LL: 26.11.21:
                            if (value.autoSize) {
                                if (preserve === 'none') {
                                    // width not set
                                    if (!hNotSet) {
                                        preserve = 'height';
                                    }
                                }
                            }
                        }
                        //LL: 25.11.21:
                        else {
                            if (hNotSet || wNotSet) {
                                autoSize = true;
                                if (wNotSet) {
                                    preserve = 'none';
                                    if (!hNotSet) {
                                        preserve = 'height';
                                    }
                                } else {
                                    preserve = 'width';
                                }
                            }
                        }

                        //LL: 26.11.21:
                        if (!value.inlineMode) {
                            if (!hNotSet && !wNotSet) {
                                autoSize = false;
                            }
                        }

                        _this.setData('settings', {
                            inlineMode: inlineMode,
                            autoSize: autoSize,
                            preserve: preserve,
                            width: value.width,
                            height: value.height,
                            wUnits: value.wUnits,
                            hUnits: value.hUnits, //LL: 21.12.23: was wUnits
                            margins: value.margins //LL: 08.06.22: To use when a parent div with margins is defined; use in Document mode
                        });

                        let container;

                        if (!_this.isReady()) {
                            container = new CKEDITOR.dom.element('div');
                            container.append(_this.wrapper);

                            editor.widgets.finalizeCreation(container);
                        }
                    });
                },
                function () {
                    reactGlobalClick.trigger(e);
                    reactGlobalClick.cancel();
                },
                function () {
                    reactGlobalClick.trigger(e);
                    reactGlobalClick.cancel();
                },
                'custom',
                {
                    deny: false,
                    confirmTitle: this.isReady() ? 'Save' : 'Insert',

                    Component: ConfigEdit,
                    FooterComponent: ConfigPopupFooter,
                    footerComponentProps: {
                        text: text,
                        onClick: clipboardCopyClick
                    },
                    componentProps: _.extend(
                        {
                            value: value,
                            tabID: tabID,
                            glob: glob,
                            onChange: onChange
                        },
                        configEditProps
                    )
                }
            );
        }
    };

    return _.extend(definition, definitionOverride);
}
